module.exports = new __parcel__URL__("inquiry_zh-tw.93abe5ba.webp").toString();